import { AxiosResponse } from "axios";
import { NotificationExtension } from "../_base/extension/NotificationExtension";
import { HanderResponse, formatFormData } from "../_base/helper/FunctionHelper";
import { API_ROUTE } from "../const/apiRoute";
import { api } from "../library/axios";
import { isNullOrUndefined } from "../_base/extension/StringExtension";
import { modals } from "@mantine/modals";

export const getDataConfigWeb = async (): Promise<any> => {
  try {
    const response: AxiosResponse = await api.post(
      `${API_ROUTE.GET_CONFIG_WEB}`
    );
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const modifyConfigWeb = async (data: any): Promise<any> => {
  try {
    const formData = new FormData();

    Object.keys(data).forEach((key) => {
      if (key === "banner") {
        const Banner = data[key];
        if (Banner) {
          Object.keys(Banner).forEach((itemKey) => {
            if (Banner.hasOwnProperty(itemKey)) {
              if (itemKey === "creationDate" || itemKey === "lastUpdateDate") {
                return;
              }

              if (Array.isArray(Banner[itemKey])) {
                Banner[itemKey].forEach((item: any, index: any) => {
                  formatFormData(item, formData, `banner.${itemKey}[${index}]`);
                });
              } else {
                const formDataKey = `banner.${itemKey}`;
                if (formDataKey) {
                  formData.append(formDataKey, Banner[itemKey]);
                }
              }
            }
          });
        }
      } else if (Array.isArray(data[key])) {
        // Handle arrays
        data[key].forEach((item: any, index: any) => {
          formatFormData(item, formData, `${key}[${index}]`);
        });
      } else if (data[key] instanceof Object && !(data[key] instanceof File)) {
        // If the value is an object (but not a File), recursively flatten it
        formatFormData(data[key], formData, key);
      } else {
        if (data[key]) {
          formData.append(key, data[key]);
        }
      }
    });

    const response: AxiosResponse = await api.post(
      API_ROUTE.MODIFY_CONFIG_WEB,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    if (!isNullOrUndefined(response) && response?.data?.success) {
      NotificationExtension.Success("Chỉnh sửa thành công !");
    } else if (response != null)
      NotificationExtension.Fails("Chỉnh sửa thất bại !");
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const getDataFAQCategory = async (query: string): Promise<any> => {
  try {
    const response: AxiosResponse = await api.get(
      API_ROUTE.GET_CATEGORY_FAQ + query
    );
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const getDataFAQ = async (query: string): Promise<any> => {
  try {
    const response: AxiosResponse = await api.get(API_ROUTE.GET_FAQ + query);
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const getDataFAQSelect = async (query: string): Promise<any> => {
  try {
    const response: AxiosResponse = await api.get(
      API_ROUTE.GET_FAQ_SELECT + query
    );
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const createFAQ = async (
  dataSubmit: any,
  onSuccess: any,
  onClose: any
): Promise<any> => {
  try {
    const response: AxiosResponse = await api.post(
      API_ROUTE.CREATE_FAQ,
      dataSubmit
    );

    if (response && response?.data?.success) {
      NotificationExtension.Success("Tạo mới FAQ thành công !");
      modals.closeAll();
      onSuccess();
      onClose();
    } else {
      NotificationExtension.Fails("Tạo mới FAQ thất bại !");
    }
  } catch (error) {
    HanderResponse(error);
  }
};

export const editFAQ = async (
  dataSubmit: any,
  onSuccess: any,
  onClose: any
): Promise<any> => {
  try {
    const response: AxiosResponse = await api.post(
      API_ROUTE.EDIT_FAQ,
      dataSubmit
    );

    if (response && response?.data?.success) {
      NotificationExtension.Success("Chỉnh sửa FAQ thành công !");
      modals.closeAll();
      onSuccess();
      onClose();
    } else {
      NotificationExtension.Fails("Chỉnh sửa FAQ thất bại !");
    }
  } catch (error) {
    HanderResponse(error);
  }
};

export const getDataEditFAQ = async (query: string): Promise<any> => {
  try {
    const response: AxiosResponse = await api.get(
      API_ROUTE.GET_EDIT_FAQ + "?" + query
    );

    if (response && response?.data?.success) {
      return response.data;
    }
  } catch (error) {
    HanderResponse(error);
  }
};

export const deleteFAQ = async (
  listId: number[],
  onSuccess: any
): Promise<any> => {
  try {
    const response: AxiosResponse = await api.post(
      API_ROUTE.DELETE_FAQ,
      listId
    );

    if (response && response?.data?.success) {
      NotificationExtension.Success("Xóa FAQ thành công !");
      modals.closeAll();
      onSuccess(true);
    } else {
      NotificationExtension.Fails("Xóa FAQ thất bại !");
    }
  } catch (error) {
    HanderResponse(error);
  }
};

export const deleteFAQtoURL = async (
  listUrl: string[],
  onSuccess: any
): Promise<any> => {
  try {
    const response: AxiosResponse = await api.post(
      API_ROUTE.DELETE_FAQ_TO_URL,
      listUrl
    );

    if (response && response?.data?.success) {
      NotificationExtension.Success("Xóa FAQ thành công !");
      modals.closeAll();
      onSuccess(true);
    } else {
      NotificationExtension.Fails("Xóa FAQ thất bại !");
    }
  } catch (error) {
    HanderResponse(error);
  }
};

export const importFAQs = async (data: any): Promise<any> => {
  try {
    const response: AxiosResponse = await api.post(
      API_ROUTE.IMPORT_EXCEL_FAQ,
      data,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};
